// This file was generated using `pay js:run gql-v1 --type=fragment --name=CardExternalAccount --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiExternalAccountCardObjectFieldType,
  OpenapiExternalAccountCardAvailablePayoutMethodsEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment CardExternalAccountFragment on OpenapiExternalAccountCard {
    id
    default_for_currency
    object
    blocklisted
    funding
    currency
    country
    brand
    exp_month
    exp_year
    last4
    available_payout_methods
    created
    dynamic_last4
    status
  }
`;

export const cardExternalAccountFragment: CardExternalAccountFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type CardExternalAccountFragmentData = {
  readonly __typename: 'OpenapiExternalAccountCard';
  readonly id: string;
  readonly default_for_currency: boolean | null;
  readonly object: OpenapiExternalAccountCardObjectFieldType;
  readonly blocklisted: boolean | null;
  readonly funding: string;
  readonly currency: string | null;
  readonly country: string | null;
  readonly brand: string;
  readonly exp_month: number;
  readonly exp_year: number;
  readonly last4: string;
  readonly available_payout_methods: ReadonlyArray<OpenapiExternalAccountCardAvailablePayoutMethodsEnum> | null;
  readonly created: number;
  readonly dynamic_last4: string | null;
  readonly status: string | null;
};

export type CardExternalAccountFragmentVariables = Exact<{
  [key: string]: never;
}>;

const cardExternalAccountFragmentPermissions = {} as const;

doc.permissions = cardExternalAccountFragmentPermissions;

export type CardExternalAccountFragmentPermissions = V1PermissionToken<
  typeof cardExternalAccountFragmentPermissions
>;

export type CardExternalAccountFragmentDocument = GraphQlDocument<
  CardExternalAccountFragmentData,
  CardExternalAccountFragmentVariables,
  CardExternalAccountFragmentPermissions
>;
